exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".features-container {\n  text-align: left;\n  margin-left: 20px; }\n  .features-container svg {\n    color: #43ac6a;\n    margin-right: 5px; }\n", ""]);

// exports
